import InstallPureKitGo from "common/purekit/install/languages/go";
import InstallPureKitJava from "common/purekit/install/languages/kotlin-java";
import InstallPureKitPHP from "common/purekit/install/languages/php";
import * as React from 'react';
export default {
  InstallPureKitGo,
  InstallPureKitJava,
  InstallPureKitPHP,
  React
};